<template>
  <div style="display:inline-block;">
    <div class="btn-group">
      <a v-if="min != 1" class="btn btn-default" v-on:click="onPageChange(1)">1..</a>
      <a
        v-bind:key="i"
        v-for="i in withinRange"
        v-on:click="onPageChange(i)"
        v-bind:class="{ 'active': i == currentPage }"
        class="btn btn-default"
      >{{i}}</a>

      <a class="btn btn-default" v-if="max != pages" v-on:click="onPageChange(pages)">..{{pages}}</a>
    </div>

    <span class="disabled btn btn-link">{{currentTotal + ' / ' + totalItems}}</span>
  </div>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    pageSize: Number,
    currentTotal: Number,
    totalItems: Number,
    onPageChange: Function,
  },
  data() {
      var pages = Math.ceil(this.currentTotal / this.pageSize);

    return {
      pages: pages,
      min: this.currentPage - 5 < 1 ? 1 : this.currentPage - 5,
      max: this.currentPage + 5 > pages ? pages : this.currentPage + 5,
    };
  },
  created() {
    this.setMinMax();
  },
  methods: {
    range(min, max) {
      var arr = [];
      for (var i = this.min; i <= this.max; i++) arr.push(i);
      return arr;
    },
    setMinMax() {
        if (this.currentTotal != 0)
            this.pages = Math.ceil(this.currentTotal / this.pageSize);
      else this.pages = 1;
      this.min = this.currentPage - 10 < 1 ? 1 : this.currentPage - 10;
      this.max =
        this.currentPage + 10 > this.pages ? this.pages : this.currentPage + 10;
    },
  },
  watch: {
    currentTotal(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setMinMax();

        if (this.currentPage == 0 && this.currentTotal > 0)
          this.onPageChange(1);

        if (this.currentPage > this.max) this.onPageChange(this.max);
      }
    },
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setMinMax();

        if (this.currentPage > this.max) this.onPageChange(this.max);
      }
    }
  },
  computed: {
    withinRange() {
      this.setMinMax();
      return this.range(this.min, this.max);
    }
  }
};
</script>

<style>
.btn-group {
  white-space: nowrap;
}
</style>